import { Box, Theme } from '@mui/material'
import { forwardRef } from 'react'

import { GLOBAL_BORDER_RADIUS } from 'providers/material-ui/theme/constants'
import { CodeFieldContainerProps } from './types'

export const CodeFieldContainer = forwardRef<HTMLDivElement, CodeFieldContainerProps>(
  ({ children, error }, ref): JSX.Element => (
    <Box
      ref={ref}
      sx={(theme: Theme) => ({
        border: `1px solid ${error ? theme.palette.error.main : theme.palette.grey[400]}`,
        borderRadius: `${GLOBAL_BORDER_RADIUS}px`,
        overflow: 'hidden',
        pl: 1,
        resize: 'both',
      })}
    >
      {children}
    </Box>
  ),
)

CodeFieldContainer.displayName = 'CodeFieldContainer'
